var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5118 7.546C18.0743 7.546 19.3418 6.28529 19.3418 4.73009C19.3418 3.17489 18.0743 1.91419 16.5118 1.91419M17.8129 10.6061C18.2795 10.6382 18.7434 10.704 19.2002 10.8063C19.8348 10.93 20.5982 11.1889 20.8699 11.7556C21.0434 12.1186 21.0434 12.5412 20.8699 12.9051C20.5991 13.4719 19.8348 13.7299 19.2002 13.8598M5.48796 7.546C3.92545 7.546 2.65793 6.28529 2.65793 4.73009C2.65793 3.17489 3.92545 1.91419 5.48796 1.91419M4.18691 10.6061C3.7203 10.6382 3.25638 10.704 2.7996 10.8063C2.16495 10.93 1.40158 11.1889 1.13073 11.7556C0.956423 12.1186 0.956423 12.5412 1.13073 12.9051C1.40068 13.4719 2.16495 13.7299 2.7996 13.8598M10.9954 11.2125C14.1615 11.2125 16.8664 11.6894 16.8664 13.5978C16.8664 15.5053 14.1794 16 10.9954 16C7.82834 16 5.12436 15.5231 5.12436 13.6147C5.12436 11.7063 7.81136 11.2125 10.9954 11.2125ZM10.9953 8.4904C8.9072 8.4904 7.23296 6.82399 7.23296 4.74475C7.23296 2.66641 8.9072 1 10.9953 1C13.0834 1 14.7576 2.66641 14.7576 4.74475C14.7576 6.82399 13.0834 8.4904 10.9953 8.4904Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.ee7e0867.svg";
export { ForwardRef as ReactComponent };